<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de produção do médico">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/pronto-atendimento/relatorio-producao-medico/List'

export default {
    components: {
        List,
    },
}
</script>